module.exports = __webpack_public_path__ + "static/media/four.97dabfcc.svg";